import { ETR_STATUS } from '../constants'

export const calculateAmount = (paymentObjectives: any) => {
  let totalPaymentObj = 0
  paymentObjectives.forEach((item: any) => {
    totalPaymentObj += +item.amount
  })
  return totalPaymentObj
}

export const getPaymentObjectivesType = (paymentObjectives: any) => {
  const typeName: any[] = []
  paymentObjectives.forEach((item: any) => {
    typeName.push(item.paymentObjectiveType.name)
  })
  return typeName.join('/')
}

export const removeTime = (date: Date) => {
  if (date === null) return date
  const data = date.toString().split('.')[0]
  // console.log(data)
  // console.log(dayjs(data).format('DD/MM/BBBB'))
  return new Date(data)
}

export const getStatusDate = (data: any): Date => {
  switch (data.status) {
    case ETR_STATUS.NEW_ETR:
      return data.receiptdate
    case ETR_STATUS.SUCCESS_ETR:
      return data.statusDate
    case ETR_STATUS.SUBMITED_ETR:
      return data.statusDate
    case ETR_STATUS.CANCEL_ETR:
      return data.canceldate
    default:
      break
  }
  return new Date()
}

export const calculateDateDiff = (first: Date, second: Date) => {
  // Copy date parts of the timestamps, discarding the time parts.
  const one = new Date(first.getFullYear(), first.getMonth(), first.getDate())
  const two = new Date(second.getFullYear(), second.getMonth(), second.getDate())
  // Do the math.
  const millisecondsPerDay = 1000 * 60 * 60 * 24
  const millisBetween = Math.abs(two.getTime() - one.getTime())
  const days = millisBetween / millisecondsPerDay
  // Round down.
  return Math.floor(days)
}

/// case new
///    >> today  - statusDate
/// case SUCCESS
///    >> SUCCESSDate  - receiptdate
/// case CANCEL
///    >> CANCEL  - receiptdate
/// case SUBMITED_ETR
///    >> statusDate  - receiptdate
export const calculateAgingDay = (data: any) => {
  const statusDate = new Date(removeTime(getStatusDate(data)))
  switch (data.status) {
    case ETR_STATUS.NEW_ETR:
      return calculateDateDiff(new Date(), new Date(statusDate))
    case ETR_STATUS.SUCCESS_ETR:
      return calculateDateDiff(
        new Date(removeTime(data.statusDate)),
        new Date(removeTime(data.receiptdate))
      )
    case ETR_STATUS.SUBMITED_ETR:
      return calculateDateDiff(new Date(), new Date(statusDate))
    case ETR_STATUS.CANCEL_ETR:
      return calculateDateDiff(
        new Date(removeTime(data.canceldate)),
        new Date(removeTime(data.receiptdate))
      )
    default:
      break
  }
}
